var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcaseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "none",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 6C23.104 6 24 6.896 24 8V20C24 21.104 23.104 22 22 22H2C0.896 22 0 21.104 0 20V8C0 6.896 0.896 6 2 6H7V4C7 2.896 7.896 2 9 2H15C16.104 2 17 2.896 17 4V6H22ZM22 8.5C22 8.224 21.776 8 21.5 8H2.5C2.224 8 2 8.224 2 8.5V19.5C2 19.776 2.224 20 2.5 20H21.5C21.776 20 22 19.776 22 19.5V8.5ZM14.5 4H9.5C9.224 4 9 4.224 9 4.5V6H15V4.5C15 4.224 14.776 4 14.5 4Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseIcon);
export default __webpack_public_path__ + "static/media/BriefcaseIcon.581227681f35d17ca50d767a27ddbf00.svg";
export { ForwardRef as ReactComponent };